module.exports = "https://bicocca-network.servercdn.it/static/fonts/FuturaPT-Heavy.woff?ec50ee1633d1684fd0431d772c35cca8";